import CompanyAccountList from '@containers/account/CompanyAccountList';

const CompanyAccountListPage = () => {
  return <CompanyAccountList />;
};

export default CompanyAccountListPage;
